export const tabsToggle = () => {
    window.addEventListener('click', event => {
      if (event.target.closest('.tabs-links__item')) {

        const container = event.target.closest('.tabs');
        const tabLink = event.target.closest('.tabs-links__item');
        const tabContent = container.querySelector(`[data-tab-content-id="${tabLink.dataset.tabLinkId}"]`);

        Array.from(container.querySelectorAll('.tabs-links__item')).find(item => (item !== tabLink && item.classList.remove('tabs-links__item--active')));
        Array.from(container.querySelectorAll('.tabs-content')).find((item) => (item.dataset.tabContentId !== tabLink.dataset.tabLinkId && item.classList.remove('tabs-content--visible')));

        tabLink.classList.add('tabs-links__item--active');
        tabContent.classList.add('tabs-content--visible');
      }
   })
}

tabsToggle();
// Hook for Safari
var ua = navigator.userAgent.toLowerCase(); 
if (ua.indexOf('safari') != -1) { 
  if (!(ua.indexOf('chrome') > -1)) {
    document.getElementById('tabs').style.marginTop='-10px';
    document.getElementById('tabs').classList.add('safari-title');
}
}
